import React from "react";

const Footer = () => {
  return (
    <footer style={{ textAlign: "center" }}>
      <small>
        FCAS pays | © 2018{" "}
        <a
          href="http://pdview.com.au"
          target="_blank"
          rel="noopener noreferrer"
        >
          pdView
        </a>{" "}
        Pty Ltd. All rights reserved.{" "}
      </small>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx